import React from "react";
import { Link, Outlet, useNavigate } from "react-router-dom";

import {
  Box,
  Button,
  IconButton,
  Heading,
  useDisclosure,
  DrawerOverlay,
  Drawer,
  DrawerContent,
  DrawerCloseButton,
  Text,
  Flex,
  Avatar,
} from "@chakra-ui/react";
import { LuLayoutDashboard } from "react-icons/lu";
import { CiViewList } from "react-icons/ci";
import { BsPerson } from "react-icons/bs";
import { BiLogOut } from "react-icons/bi";
import { authhome } from "../../images/svg";
import { HamburgerIcon } from "@chakra-ui/icons";
import { FaListCheck } from "react-icons/fa6";
import { MdLogout } from "react-icons/md";
import { GoBell } from "react-icons/go";
import { FaCreditCard } from "react-icons/fa";
import { IoNotificationsOutline } from "react-icons/io5";
import { GoTag } from "react-icons/go";
import { FaHome, FaGlobe } from "react-icons/fa";
import { getNotifcations } from "../../utils/fetch";
import { useQuery } from "react-query";
export const DashboardLayout = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const admin = JSON.parse(localStorage.getItem("isAdmin"));
  const btnRef = React.useRef();
  const logoutHandler = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("email");
    localStorage.removeItem("isAdmin");
    localStorage.removeItem("firstname");
    localStorage.removeItem("lastname");
    localStorage.removeItem("user_id");
    localStorage.removeItem("phone");
    localStorage.removeItem("listingRedirect");
    window.location.href = "/";
  };
  //"#b4816b"

  const firstName = JSON.parse(localStorage.getItem("firstname"));
  const lastname = JSON.parse(localStorage.getItem("lastname"));
  const user_id = JSON.parse(localStorage.getItem("user_id"));

  const { data, isLoading } = useQuery(["get-notification", user_id], () =>
    getNotifcations(user_id)
  );
  const navigate = useNavigate();
  const menuList = admin
    ? [
        { name: "Dashboard", link: "/admin/home", icon: <LuLayoutDashboard /> },
        { name: "Listing", link: "/admin/listing", icon: <FaHome /> },
        { name: "Offer", link: "/admin/offers", icon: <GoTag /> },
        {
          name: "Transactions",
          link: "/admin/transactions",
          icon: <FaCreditCard />,
        },
        {
          name: "Notification",
          link: "/admin/notifications",
          icon: <IoNotificationsOutline />,
        },

        {
          name: "Update Profile",
          link: "/admin/profile",
          icon: <BsPerson />,
        },
      ]
    : [
        { name: "My Listing", link: "/admin/listing", icon: <FaHome /> },
        { name: "Offer", link: "/admin/offers", icon: <GoTag /> },
        {
          name: "Transactions",
          link: "/admin/transactions",
          icon: <FaCreditCard />,
        },
        {
          name: "Notification",
          link: "/admin/notifications",
          icon: <IoNotificationsOutline />,
        },

        {
          name: "Update Profile",
          link: "/admin/profile",
          icon: <BsPerson />,
        },
      ];
  return (
    <Box display="flex" h="100vh">
      <Box
        w={["", "", "230px", "250px", "250px", "250px"]}
        display={["none", "none", "block", "block"]}
        border="1px solid #E9E9E9"
      >
        <Link to={admin ? "/admin/home" : "/admin/listing"}>
          <Heading
            size="md"
            p="20px"
            mb="30px"
            borderBottom="1px solid #E9E9E9"
            w="100%"
          >
            {authhome}
          </Heading>
        </Link>
        <Box px="15px">
          {menuList.map((item) => (
            <Button
              key={item?.link}
              w="100%"
              variant={
                window.location.pathname.includes(`${item?.link}`)
                  ? "primaryAdmin"
                  : "primaryAdmin2"
              }
              mb="10px"
              onClick={() => {
                navigate(`${item?.link}`);
              }}
              display="flex"
              justifyContent="left"
            >
              <Box display="flex">
                <Text mt="3.3px" mr="5px">
                  {item?.icon}
                </Text>
                {item?.name}
              </Box>
            </Button>
          ))}
          <Button
            w="100%"
            variant="primaryAdmin2"
            mb="10px"
            onClick={() => {
              navigate(`/`);
            }}
            display="flex"
            justifyContent="left"
          >
            <Box display="flex">
              <Text mt="3.3px" mr="5px">
                <FaGlobe />
              </Text>
              Go To Home Page
            </Box>
          </Button>
          <Button
            w="100%"
            variant="primaryAdmin2"
            mb="10px"
            onClick={() => {
              logoutHandler();
            }}
            display="flex"
            justifyContent="left"
          >
            <Box display="flex">
              <Text mt="3.3px" mr="5px">
                <MdLogout />
              </Text>
              Log Out
            </Box>
          </Button>
        </Box>
      </Box>
      <Box overflowY="scroll" w="100%">
        <Box
          border="1px solid #E9E9E9"
          justifyContent="space-between"
          mb="10px"
          p="10px"
          display={["flex", "flex", "none", "none"]}
        >
          <Link to="/admin/home">
            <Heading size="md" p="0px" w="100%">
              {authhome}
            </Heading>
          </Link>

          <Button
            as={IconButton}
            onClick={onOpen}
            aria-label="Options"
            icon={<HamburgerIcon />}
            variant=""
          />
          <Drawer
            isOpen={isOpen}
            placement="right"
            onClose={onClose}
            finalFocusRef={btnRef}
            size="xs"
          >
            <DrawerOverlay />
            <DrawerContent textAlign="left">
              <DrawerCloseButton />
              <Box mt="70px">
                {menuList?.map((data) => (
                  <Box key={data?.name}>
                    <Button
                      variant="transpare"
                      onClick={() => {
                        window.location.href = `${data?.link}`;
                      }}
                    >
                      {data?.name}
                    </Button>
                    <br></br>
                  </Box>
                ))}
                <Button
                  variant="transpare"
                  onClick={() => {
                    navigate(`/`);
                  }}
                >
                  Go to Home Page
                </Button>
                <br></br>
                <Button
                  color="red"
                  variant="transpare"
                  onClick={() => {
                    logoutHandler();
                    onClose(true);
                  }}
                >
                  Logout
                </Button>
              </Box>
            </DrawerContent>
          </Drawer>
        </Box>
        <Box
          bg="white"
          justifyContent="space-between"
          mb="10px"
          p="16.8px"
          display={["none", "none", "flex", "flex"]}
          borderBottom="1px solid #E9E9E9"
        >
          <Heading mt="15px" size="md">
            Welcome {firstName}
          </Heading>

          <Flex>
            <Flex
              mt="12px"
              mr="30px"
              cursor="pointer"
              onClick={() => navigate("/admin/notifications")}
            >
              <GoBell size="30px" />
              <Box
                px="6px"
                h="20px"
                color="white"
                bg="red"
                borderRadius="20px"
                fontSize="13px"
                ml="-13px"
                mt="-3px"
              >
                {data?.data?.data.length ? data?.data?.data.length : 0}
              </Box>
            </Flex>
            <Avatar name={`${firstName} ${lastname}`} />
            <Box ml="10px">
              <b>
                {firstName} {lastname}
              </b>
              <Text fontSize="sm">{admin ? "Admin" : "User"} </Text>
            </Box>
          </Flex>
        </Box>
        <Box p={["8px", "8px", "8px", "20px", "20px", "20px"]}>
          <Outlet />
        </Box>
      </Box>
    </Box>
  );
};
